import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { DashboardFilters } from "@/domain/types/filters/types";

export const DEFAULT_FISCAL_YEAR = new Date().getFullYear();

interface DashboardFiltersState {
	filters: DashboardFilters;
	setBeneficiaryFilter: (beneficiary_uuid: string | null) => void;
	setFiscalYearFilter: (fiscal_year: number) => void;
	clearFilters: () => void;
	reset: () => void;
}

const initialFilters: DashboardFilters = {
	beneficiary_uuid: null,
	fiscal_year: DEFAULT_FISCAL_YEAR,
};

export const useDashboardFiltersStore = create<DashboardFiltersState>()(
	devtools(
		(set) => ({
			filters: { ...initialFilters },
			setBeneficiaryFilter: (beneficiary_uuid) =>
				set((state) => ({ filters: { ...state.filters, beneficiary_uuid } })),
			setFiscalYearFilter: (fiscal_year) =>
				set((state) => ({ filters: { ...state.filters, fiscal_year } })),
			clearFilters: () => set({ filters: { ...initialFilters } }),
			reset: () => set({ filters: { ...initialFilters } }),
		}),
		{ name: "DashboardFiltersStore" },
	),
);
